import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hi Everyone, I am <span className="purple">Aneesh Aggarwal </span>
            from <span className="purple"> Radaur, India.</span>
            <br />
            I am currently pursuing Bachelors in Computer Science and
            Engineering at Chitkara University. I have 2 year of experience
            working on web development and ability to collaborate effectively
            with the senior developers and also know about UX. I have hands-on
            experience working with React JS and maintaing the better code base
            for reusabilty and I enjoy working closely with team members with
            the passion of personal growth.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Playing Games
            </li>
            <li className="about-activity">
              <ImPointRight /> Travelling
            </li>
          </ul>

          <p style={{ color: "rgb(155 126 172)" }}>
            "Strive to build things that make a difference!"{" "}
          </p>
          <footer className="blockquote-footer">Aneesh</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
